// http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
declare let opr: any;
declare let InstallTrigger: any;
declare let safari: any;

// Opera 8.0+
const isOpera = (!!(window as any).opr && !!opr.addons) || !!(window as any).opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
const isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
const isSafari =
  /constructor/i.test((window as any).HTMLElement) ||
  (p => p.toString() === '[object SafariRemoteNotification]')(!(window as any).safari || (typeof safari !== 'undefined' && safari.pushNotification));

// source: Gemini
const isIOS = (function (): boolean {
  // 1. Check if the browser claims to be a Mac (captures both macOS and iPadOS)
  const isMac = /Macintosh/i.test(navigator.userAgent);

  // 2. Distinguish iPadOS from macOS by checking for a touchscreen
  // MacBooks return 0, iPads return 5
  const isTouch = navigator.maxTouchPoints > 0;

  // 3. iPhones still usually identify as 'iPhone' in the User Agent
  const isIPhone = /iPhone/i.test(navigator.userAgent);

  return isIPhone || (isMac && isTouch);
})();

// Internet Explorer 6-11
const isIE = /*@cc_on!@*/ !!(document as any).documentMode;

// Edge 20+
// https://learn.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-guidance
const isEdge = !isIE && navigator.userAgent.indexOf(' Edg/') >= 0;

// Chrome 1 - 71
const isChrome = !!(window as any).chrome && (!!(window as any).chrome.webstore || !!(window as any).chrome.runtime || /Google Inc/.test(navigator.vendor));

// Blink engine detection
const isBlink = (isChrome || isOpera) && !!(window as any).CSS;

// Android detection
const isAndroid = window.navigator.userAgent.indexOf('Android') > -1;

let desktopScreen: boolean;
let smartphoneScreen: boolean;
let tabletScreen: boolean;

function setScreenVars(): void {
  desktopScreen = window.matchMedia('(min-width: 1025px)').matches;
  smartphoneScreen = window.matchMedia('(max-width: 599px)').matches;
  tabletScreen = !desktopScreen && !smartphoneScreen;
}

window.addEventListener('resize', setScreenVars);
window.matchMedia && setScreenVars();

export const isDesktopScreen = () => desktopScreen;
export const isSmartphoneScreen = () => smartphoneScreen;
export const isTabletScreen = () => tabletScreen;

export class BrowserCheck {
  public static isOpera(): boolean {
    return isOpera;
  }

  // see http://stackoverflow.com/a/4819886
  public static isTouchDevice(): boolean {
    return (
      'ontouchstart' in window || // works on most browsers
      navigator.maxTouchPoints > 0
    ); // works on IE10/11 and Surface
  }

  public static isEdge(): boolean {
    return isEdge;
  }

  public static isChrome(): boolean {
    return isChrome;
  }

  public static isFirefox(): boolean {
    return isFirefox;
  }

  /**
   * Source:
   * ChatGPT + https://stackoverflow.com/questions/56934826/distinguish-between-ipad-and-mac-on-ipad-with-ipados
   */
  public static isMacOS(): boolean {
    const userAgent = navigator.userAgent || '';
    const isMacAgent = /Macintosh|Mac OS X/i.test(userAgent);

    // iPads in "Request Desktop Site" mode report as Macintosh,
    // but they have touch points > 0
    const hasTouch = navigator.maxTouchPoints && navigator.maxTouchPoints > 0;

    return isMacAgent && !hasTouch;
  }

  /**
   * Matches Safari browser AND any iOS browser (including Chrome, Firefox, etc.) - as long as they are still using the
   * webkit engine (this might change in the near future, at least in Europe: https://www.theverge.com/2024/1/25/24050478/apple-ios-17-4-browser-engines-eu)
   */
  public static isSafari(): boolean {
    // all iOS browsers are forced to use webkit under the hood. (note: this will change in the future (possibly)
    // see https://www.theverge.com/2024/1/25/24050478/apple-ios-17-4-browser-engines-eu)
    // this means that we should use the same check for all iOS browsers as for Safari. to be a bit future-proof, we
    // already exclude blink and firefox (should they change their engine to their own for europe users in the future)
    return isSafari || (isIOS && !isBlink && !isFirefox);
  }

  public static isIOS(): boolean {
    return isIOS;
  }

  public static isBlink(): boolean {
    return isBlink;
  }

  public static isAndroid(): boolean {
    return isAndroid;
  }

  public static isAndroidOrIos(): boolean {
    return this.isIOS() || this.isAndroid();
  }

  // this has room for improvement...
  public static getBrowserInfo(): string {
    const device: string = this.isTouchDevice() ? ' (touch)' : ' (desktop)';
    if (isIE) {
      return 'IE' + device;
    }
    if (isEdge) {
      return 'Edge' + device;
    }
    if (isChrome) {
      return 'Chrome' + device;
    }
    if (isFirefox) {
      return 'Firefox' + device;
    }
    if (isSafari) {
      return 'Safari' + device;
    }
    if (isIOS) {
      return 'IOS' + device;
    }
    if (isOpera) {
      return 'Opera' + device;
    }
    if (isAndroid) {
      return 'Android' + device;
    }
    return 'Unknown Browser' + device;
  }

  // see https://stackoverflow.com/questions/77903642/unable-to-detect-underlying-os-using-js
  public static getOsInfo(): 'MacOS' | 'iOS' | 'Windows' | 'Android' | 'Linux' {
    // if a browser has no support for navigator.userAgentData.platform use platform as fallback
    const userAgent = ((window.navigator as any).userAgentData?.platform ?? window.navigator.platform).toLowerCase();

    if (this.isMacOS()) {
      return 'MacOS';
    } else if (isIOS) {
      return 'iOS';
    } else if (userAgent.includes('win')) {
      return 'Windows';
    } else if (/Android/.test(userAgent)) {
      return 'Android';
    } else if (userAgent.includes('linux')) {
      return 'Linux';
    }

    return null;
  }
}
